import { FiMoreHorizontal } from "react-icons/fi";
import "./btnThreeDotMenu.scss";

const BtnThreeDotMenu = () => {
  return <FiMoreHorizontal className="btn-three-dot-menu" />;
};

export default BtnThreeDotMenu;
